// TODO: Simplify the way the sidebar is controlled once Marble is fully deployed.
export const generateSidebarController = (setHelptoolIsOpen, setSidePanelOpen) => (isOpen) => {
    if (setSidePanelOpen) {
        setHelptoolIsOpen(isOpen);
        setSidePanelOpen(isOpen);
    }
};
